// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media only screen {
  .parameters-values {
    margin-top: 10px;
    padding: 0 1rem;
    margin-bottom: 20px;
  }
  .parameter-value {
    margin-left: auto;
    margin-right: auto;
  }
  .parameter-value .select-list-container:after {
    display: none;
  }
  .attr-value.selected {
    color: var(--dms-color);
  }
  .attr-label.selected {
    color: var(--ion-color-secondary);
  }
  .select-list-container label.attr-label.bold {
    color: var(--ion-color-secondary);
  }
  .label {
    display: inline-block;
    width: auto;
  }
  .select-list-container.label {
    width: auto;
    width: 90%;
    max-width: xrem(80px);
    float: left;
    text-align: center;
    display: inline-block;
    color: var(--dms-color);
    font-size: xrem(12px);
    font-weight: 500;
    letter-spacing: xrem(-0.4px);
    line-height: 1.05;
    padding: xrem(18px) 0;
    vertical-align: middle;
    cursor: pointer;
  }
  .select-list-container.label:first-child {
    text-align: left;
  }
  .select-list-container.label:last-child {
    width: xrem(30px);
    text-align: right;
    padding-right: xrem(3px);
    margin-right: 0;
    float: right;
  }
  .select-list-item-select.boxy .attr-label {
    width: calc(100% - 48px);
  }
  .select-list-container.inline label {
    font-weight: 400;
    color: var(--mc-color-mid-grey);
    text-transform: uppercase;
    font-size: 12px;
  }
  .attr-label .selected {
    font-weight: 700;
  }
  .attr-label .sublabel {
    padding-left: 10px;
    font-weight: 400;
    opacity: 0.6;
  }
  .select-list-container .desc span:after {
    font-family: "icomoon";
    content: " \\e900";
    color: var(--mc-text-8a);
    font-size: 12px;
  }
  .select-list-container .asc span:after {
    font-family: "icomoon";
    content: " \\e902";
    color: var(--mc-text-8a);
    font-size: 12px;
  }
  .select-list-container.boxy {
    width: auto;
    height: auto;
    flex: 1;
  }
  .select-list-container.boxy .select-text {
    flex: 1;
    min-width: 16px;
    font-size: inherit;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    position: relative;
  }
  .select-list-container.boxy .select-icon {
    width: 12px;
    height: 18px;
    position: relative;
    float: right;
  }
  .select-list-container.boxy .select-icon .select-icon-inner {
    left: 5px;
    top: 50%;
    margin-top: -3px;
    position: absolute;
    width: 0;
    height: 0;
    border-top: 5px solid;
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
    color: currentColor;
    opacity: 0.33;
    pointer-events: none;
  }
  .select-list-container.boxy span:after {
    font-family: "icomoon";
    content: "\\e5c5";
  }
  .select-list-container.desc:after {
    font-family: "icomoon";
    content: "\\e900";
    color: var(--mc-text-8a);
    font-size: 12px;
  }
  .select-list-container.asc:after {
    font-family: "icomoon";
    content: "\\e902";
    color: var(--mc-text-8a);
    font-size: 12px;
  }
  .add-new {
    color: var(--ion-color-primary);
    text-align: center;
    cursor: pointer;
    font-weight: 400;
    font-size: 14px;
    margin-left: -10px;
  }
}
/* min-width 375px, small screens */
@media only screen and (min-width: 375px) {
  .select-list-container.label {
    font-size: xrem(14px);
    width: auto;
    margin-right: xrem(24px);
    max-width: none;
  }
  .select-list-container.label:last-child {
    width: auto;
    float: right;
  }
}
:host ::ng-deep .thumbnail {
  width: 56px;
  max-width: 56px;
  max-height: 56px;
  height: 56px;
  overflow: visible;
  border-radius: 7px;
  margin-left: 50px;
  background-color: var(--mc-thumbnail-bg);
}
:host ::ng-deep .thumbnail img {
  min-height: 56px;
  min-width: auto;
  max-width: initial;
}

.select-all-footer ion-toolbar {
  --min-height: 44px;
  padding-inline: 6px;
}
.select-all-footer ion-button {
  font-weight: 500;
}

.select-list-modal,
.modal-details-content {
  --padding-bottom: 60px;
}

.footer-action {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/select-list/select-list-modal.component.scss"],"names":[],"mappings":"AAGA;EACC;IACC,gBAAA;IACA,eAAA;IACA,mBAAA;EAFA;EAKD;IACC,iBAAA;IACA,kBAAA;EAHA;EAMC;IACC,aAAA;EAJF;EAaD;IACC,uBAAA;EAXA;EAcD;IACC,iCAAA;EAZA;EAcD;IACC,iCAAA;EAZA;EAeD;IACC,qBAAA;IACA,WAAA;EAbA;EAgBD;IACC,WAAA;IACA,UAAA;IACA,qBAAA;IACA,WAAA;IACA,kBAAA;IACA,qBAAA;IACA,uBAAA;IACA,qBAAA;IACA,gBAAA;IACA,4BAAA;IACA,iBAAA;IACA,qBAAA;IACA,sBAAA;IACA,eAAA;EAdA;EAmBA;IACC,gBAAA;EAjBD;EAoBA;IACC,iBAAA;IACA,iBAAA;IACA,wBAAA;IACA,eAAA;IACA,YAAA;EAlBD;EAsBD;IACC,wBAAA;EApBA;EAwBA;IACC,gBAAA;IACA,+BAAA;IACA,yBAAA;IACA,eAAA;EAtBD;EA8BA;IACC,gBAAA;EA5BD;EA8BA;IACC,kBAAA;IACA,gBAAA;IACA,YAAA;EA5BD;EAiCA;IACC,sBAAA;IACA,iBAAA;IACA,wBAAA;IACA,eAAA;EA/BD;EAkCA;IACC,sBAAA;IACA,iBAAA;IACA,wBAAA;IACA,eAAA;EAhCD;EAqCA;IACC,WAAA;IACA,YAAA;IACA,OAAA;EAnCD;EAoCC;IAEC,OAAA;IACA,eAAA;IACA,kBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;EAlCF;EAoCC;IACC,WAAA;IACA,YAAA;IACA,kBAAA;IACA,YAAA;EAlCF;EAmCE;IACC,SAAA;IACA,QAAA;IACA,gBAAA;IACA,kBAAA;IACA,QAAA;IACA,SAAA;IACA,qBAAA;IACA,mCAAA;IACA,kCAAA;IACA,mBAAA;IACA,aAAA;IACA,oBAAA;EAjCH;EAqCA;IACC,sBAAA;IACA,gBAAA;EAnCD;EAqCA;IACC,sBAAA;IACA,gBAAA;IACA,wBAAA;IACA,eAAA;EAnCD;EAsCA;IACC,sBAAA;IACA,gBAAA;IACA,wBAAA;IACA,eAAA;EApCD;EAwCD;IACC,+BAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,eAAA;IACA,kBAAA;EAtCA;AACF;AAwCA,mCAAA;AACA;EACC;IACC,qBAAA;IACA,WAAA;IACA,wBAAA;IACA,eAAA;EAtCA;EAwCA;IACC,WAAA;IACA,YAAA;EAtCD;AACF;AA4CI;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACN,wCAAA;AA1CF;AA6CQ;EACI,gBAAA;EACA,eAAA;EACA,kBAAA;AA3CZ;;AAkDE;EACE,kBAAA;EACA,mBAAA;AA/CJ;AAiDE;EACE,gBAAA;AA/CJ;;AAmDA;;EAEE,sBAAA;AAhDF;;AAmDA;EACI,eAAA;AAhDJ","sourcesContent":["\r\n// @import \"./theme/mixins.scss\";\r\n\r\n@media only screen {\r\n\t.parameters-values {\r\n\t\tmargin-top: 10px;\r\n\t\tpadding: 0 1rem;\r\n\t\tmargin-bottom: 20px;\r\n\t}\r\n\r\n\t.parameter-value {\r\n\t\tmargin-left: auto;\r\n\t\tmargin-right: auto;\r\n\r\n\t\t.select-list-container {\r\n\t\t\t&:after {\r\n\t\t\t\tdisplay: none;\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// &.all .select-list-container:before {\r\n\t\t//     display: none;\r\n\t\t// }\r\n\t}\r\n\r\n\t.attr-value.selected {\r\n\t\tcolor: var(--dms-color);\r\n\t}\r\n\r\n\t.attr-label.selected {\r\n\t\tcolor: var(--ion-color-secondary);\r\n\t}\r\n\t.select-list-container label.attr-label.bold {\r\n\t\tcolor: var(--ion-color-secondary);\r\n\t}\r\n\r\n\t.label {\r\n\t\tdisplay: inline-block;\r\n\t\twidth: auto;\r\n\t}\r\n\r\n\t.select-list-container.label {\r\n\t\twidth: auto;\r\n\t\twidth: 90%;\r\n\t\tmax-width: xrem(80px);\r\n\t\tfloat: left;\r\n\t\ttext-align: center;\r\n\t\tdisplay: inline-block;\r\n\t\tcolor: var(--dms-color);\r\n\t\tfont-size: xrem(12px);\r\n\t\tfont-weight: 500;\r\n\t\tletter-spacing: xrem(-0.4px);\r\n\t\tline-height: 1.05;\r\n\t\tpadding: xrem(18px) 0;\r\n\t\tvertical-align: middle;\r\n\t\tcursor: pointer;\r\n\r\n\t\t&:hover {\r\n\t\t}\r\n\r\n\t\t&:first-child {\r\n\t\t\ttext-align: left;\r\n\t\t}\r\n\r\n\t\t&:last-child {\r\n\t\t\twidth: xrem(30px);\r\n\t\t\ttext-align: right;\r\n\t\t\tpadding-right: xrem(3px);\r\n\t\t\tmargin-right: 0;\r\n\t\t\tfloat: right;\r\n\t\t}\r\n\t}\r\n\r\n\t.select-list-item-select.boxy .attr-label {\r\n\t\twidth: calc(100% - 48px);\r\n\t}\r\n\r\n\t.select-list-container.inline {\r\n\t\tlabel {\r\n\t\t\tfont-weight: 400;\r\n\t\t\tcolor: var(--mc-color-mid-grey);\r\n\t\t\ttext-transform: uppercase;\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\t}\r\n\t.dropdown-arrow {\r\n\t}\r\n\r\n\t.attr-label {\r\n\t\t// color: rgb(45,45,45);\r\n\t\t.selected {\r\n\t\t\tfont-weight: 700;\r\n\t\t}\r\n\t\t.sublabel {\r\n\t\t\tpadding-left: 10px;\r\n\t\t\tfont-weight: 400;\r\n\t\t\topacity: 0.6;\r\n\t\t}\r\n\t}\r\n\r\n\t.select-list-container {\r\n\t\t.desc span:after {\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t\tcontent: \" \\e900\";\r\n\t\t\tcolor: var(--mc-text-8a);\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\r\n\t\t.asc span:after {\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t\tcontent: \" \\e902\";\r\n\t\t\tcolor: var(--mc-text-8a);\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\t}\r\n\r\n\t.select-list-container {\r\n\t\t&.boxy {\r\n\t\t\twidth: auto;\r\n\t\t\theight: auto;\r\n\t\t\tflex: 1;\r\n\t\t\t.select-text {\r\n\t\t\t\t-ms-flex: 1;\r\n\t\t\t\tflex: 1;\r\n\t\t\t\tmin-width: 16px;\r\n\t\t\t\tfont-size: inherit;\r\n\t\t\t\ttext-overflow: ellipsis;\r\n\t\t\t\twhite-space: nowrap;\r\n\t\t\t\toverflow: hidden;\r\n\t\t\t\tposition: relative;\r\n\t\t\t}\r\n\t\t\t.select-icon {\r\n\t\t\t\twidth: 12px;\r\n\t\t\t\theight: 18px;\r\n\t\t\t\tposition: relative;\r\n\t\t\t\tfloat: right;\r\n\t\t\t\t.select-icon-inner {\r\n\t\t\t\t\tleft: 5px;\r\n\t\t\t\t\ttop: 50%;\r\n\t\t\t\t\tmargin-top: -3px;\r\n\t\t\t\t\tposition: absolute;\r\n\t\t\t\t\twidth: 0;\r\n\t\t\t\t\theight: 0;\r\n\t\t\t\t\tborder-top: 5px solid;\r\n\t\t\t\t\tborder-right: 5px solid transparent;\r\n\t\t\t\t\tborder-left: 5px solid transparent;\r\n\t\t\t\t\tcolor: currentColor;\r\n\t\t\t\t\topacity: 0.33;\r\n\t\t\t\t\tpointer-events: none;\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\t\t&.boxy span:after {\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t\tcontent: \"\\e5c5\";\r\n\t\t}\r\n\t\t&.desc:after {\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t\tcontent: \"\\e900\";\r\n\t\t\tcolor: var(--mc-text-8a);\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\r\n\t\t&.asc:after {\r\n\t\t\tfont-family: \"icomoon\";\r\n\t\t\tcontent: \"\\e902\";\r\n\t\t\tcolor: var(--mc-text-8a);\r\n\t\t\tfont-size: 12px;\r\n\t\t}\r\n\t}\r\n\r\n\t.add-new {\r\n\t\tcolor: var(--ion-color-primary);\r\n\t\ttext-align: center;\r\n\t\tcursor: pointer;\r\n\t\tfont-weight: 400;\r\n\t\tfont-size: 14px;\r\n\t\tmargin-left: -10px;\r\n\t}\r\n}\r\n/* min-width 375px, small screens */\r\n@media only screen and (min-width: 375px) {\r\n\t.select-list-container.label {\r\n\t\tfont-size: xrem(14px);\r\n\t\twidth: auto;\r\n\t\tmargin-right: xrem(24px);\r\n\t\tmax-width: none;\r\n\r\n\t\t&:last-child {\r\n\t\t\twidth: auto;\r\n\t\t\tfloat: right;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n:host ::ng-deep {\r\n    .thumbnail {\r\n        width: 56px;\r\n        max-width: 56px;\r\n        max-height: 56px;\r\n        height: 56px;\r\n        overflow:visible;\r\n        border-radius: 7px;\r\n        margin-left: 50px;\r\n\t\tbackground-color: var(--mc-thumbnail-bg);\r\n\r\n\r\n        img {\r\n            min-height: 56px;\r\n            min-width: auto;\r\n            max-width: initial;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.select-all-footer {\r\n  ion-toolbar {\r\n    --min-height: 44px;\r\n    padding-inline: 6px;\r\n  }\r\n  ion-button {\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n.select-list-modal,\r\n.modal-details-content {\r\n  --padding-bottom: 60px;\r\n}\r\n\r\n.footer-action {\r\n    font-size: 15px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
